import { rem } from "polished";
import type { ReactNode } from "react";
import { ThemeKind } from "src/types";
import styled from "styled-components";

import { getInvertedColor } from "@/components/editor/utils/colors";
import { ColorLabels } from "@/components/editor/utils/use-color";

type NotificationProps = {
  children: ReactNode;
  "aria-label"?: string;
  role?: "status" | "alert";
  "data-testid"?: string;
  className?: string;
};

export const Notification = styled.div<NotificationProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: ${rem(20)};
  width: ${rem(20)};
  height: ${rem(20)};
  border-radius: 50%;
  background: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
  color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  font-size: ${rem(12)};
  line-height: ${rem(14)};
  font-weight: ${({ theme }) =>
    theme.typography.patterns.headingTwo.fontWeight};
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  text-align: center;

  &.${ThemeKind.CROSBY}, &.${ThemeKind.DEFAULT} {
    color: ${({ theme }) =>
      getInvertedColor(theme.colors[ColorLabels.PRIMARY])};
  }
`;
